import cn from 'clsx';
import { FC, HTMLAttributes } from 'react';

import { Justify } from '../../types/justify.type';

import s from './Modal.module.scss';

interface Props {
  justify?: Justify;
}

type NativeAttrs = Omit<HTMLAttributes<HTMLDivElement>, keyof Props>;

export type ModalFooterProps = Props & NativeAttrs;

const ModalFooter: FC<React.PropsWithChildren<React.PropsWithChildren<ModalFooterProps>>> = ({ children, justify = 'center', ...props }) => {
  return (
    <div className={cn(s.footer, `justify-${justify}`)} {...props}>
      {children}
    </div>
  );
};

export default ModalFooter;
